module.exports = {"220173001":"硅谷街道","220173002":"北湖街道","220173003":"超越街道","220173004":"飞跃街道","220173005":"双德街道","220173200":"奋进乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220173.json
// module id = 701
// module chunks = 0